import type { FC } from 'react';
import type { TPlacementHostCompany } from '@shared/types/placement-host-company';
import ViewHostHeader from './view-host-header';
import BasicInformation from './basic-information';
import AddressInformation from './address-information';
import ContactInformation from './contact-information';
import HostCustomFields from './host-custom-fields';

const ViewHostModal: FC<{ host: TPlacementHostCompany }> = ({ host }) => {
  return (
    <>
      <ViewHostHeader host={host} />
      <div className='space-y-4 overflow-y-auto scrollbar-gray max-h-[77vh]'>
        <BasicInformation host={host} />
        <AddressInformation host={host} />
        <ContactInformation host={host} />
        <HostCustomFields host={host} />
      </div>
    </>
  );
};

export default ViewHostModal;
